var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-listing__view", class: { "is-loading": _vm.loading } },
    [
      _vm.hasListings
        ? _c(
            "div",
            [
              _c(
                "transition-group",
                {
                  staticClass: "row js--faded-hoverContainer",
                  attrs: { name: "fade", tag: "div" },
                },
                _vm._l(_vm.filteredListings, function (listing, index) {
                  return _c(
                    "div",
                    {
                      key: `listing${index}`,
                      staticClass:
                        "col-24 col-sm-12 col-md-8 room-listing__listings js--faded-hoverItem",
                      class: {
                        "hover-fadeout-listing":
                          !listing.hovered && _vm.anyListingsHovered,
                      },
                    },
                    [
                      _c("listing", {
                        attrs: {
                          "listing-type": _vm.listingsType,
                          title: listing.title,
                          url: listing.url,
                          image: listing.image,
                          imageAlt: listing.imageAlt ? listing.imageAlt : "",
                          category: listing.roomType
                            ? listing.roomType
                            : undefined,
                          "room-view": listing.roomView
                            ? listing.roomView
                            : undefined,
                          "pool-label": listing.hasPoolLabel
                            ? listing.hasPoolLabel
                            : undefined,
                          "occupancy-label": listing.occupancyLabel
                            ? listing.occupancyLabel
                            : undefined,
                          exploreLabel: listing.callToAction,
                          "dimensions-label": listing.dimensionsLabel
                            ? listing.dimensionsLabel
                            : undefined,
                          "guide-for": listing.guideFor
                            ? listing.guideFor
                            : undefined,
                          "guide-time": listing.guideTime
                            ? listing.guideTime
                            : undefined,
                          featured: listing.featured,
                          "is-hovered": listing.hovered,
                          theme: _vm.theme,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          )
        : _c("div", { staticClass: "room-listing__no-results" }, [
            _c("p", [_vm._v(_vm._s(_vm.ListingNoResultsText))]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }